import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header/Header";

const HeaderAllow = (props) => {
  const { setAdmin } = props;
  const location = useLocation();
  const headerPaths = [
    "/",
    "/package",
    "/manage/contact",
    "/bus-layout",
    "/manage/package",
    "/manage/booking",
    "/manage/user-contact",
    "/info",
    "/manage/info",
    "/manage/cancel-booking",
    "/manage/date-wise-booking",
    "/offer",
    "/manage/offer",
    "/admin-booking",
    "/admin-seatlock",
    "/admin-seat-unlock",
    "/manage/pdfgenerate",
    "/offline-payment-report",
    "/admin-seatlock-report"
  ];
  return (
    <>
      {headerPaths.includes(location.pathname) && (
        <Header setAdmin={setAdmin} />
      )}
    </>
  );
};

export default HeaderAllow;
